<template>
  <b-card class="filter assignment-filters-card">
    <div class="d-flex flex-wrap align-items-center assignment-filters">
      <SearchFilter />
      <CompanyFilter v-if="can('manage', 'staff.area')" />
      <DateFilter />
      <ArchiveModeFilter />
      <DistributionChannelFilter />
      <StatusFilter />
      <TypeFilter />
      <AddButton />
    </div>
  </b-card>
</template>

<script lang="ts">
import { BCard } from 'bootstrap-vue-next'
import { computed, defineComponent } from 'vue'
import { useAccountStore } from '@/store/account'
import AddButton from '@/views/Components/Assignment/AddButton.vue'
import DateFilter from '@/views/Components/Assignment/Filters/DateFilter.vue'
import TypeFilter from '@/views/Components/Assignment/Filters/TypeFilter.vue'
import SearchFilter from '@/views/Components/Assignment/Filters/SearchFilter.vue'
import StatusFilter from '@/views/Components/Assignment/Filters/StatusFilter.vue'
import CompanyFilter from '@/views/Components/Assignment/Filters/CompanyFilter.vue'
import ArchiveModeFilter from '@/views/Components/Assignment/Filters/ArchiveMode.vue'
import DistributionChannelFilter from '@/views/Components/Assignment/Filters/DistributionChannelFilter.vue'

export default defineComponent({
  name: 'FiltersWrap',
  components: {
    BCard,
    AddButton,
    SearchFilter,
    CompanyFilter,
    ArchiveModeFilter,
    DistributionChannelFilter,
    DateFilter,
    TypeFilter,
    StatusFilter,
  },
  setup() {
    const accountStore = useAccountStore()

    const ability = computed(() => accountStore.ability)
    const can = (rule: string, section: string) => ability.value.can(rule as any, section as any)

    return { can }
  },
})
</script>
